import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import PL from './locales/pl';

i18n.use(initReactI18next).init({
  lng: localStorage.getItem("lng") || "pl",
  fallbackLng: "pl",
  interpolation: {
    escapeValue: false,
  },
  languages: ["pl"],
  resources: {
    pl: PL
  },
});

export default i18n;